import { inject, Injectable } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class EmbedService {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  embed: boolean;

  constructor() {
    this.router.events.pipe(untilDestroyed(this)).subscribe({
      next: event => {
        if (event instanceof NavigationEnd) {
          if (this.embed == undefined) {
            this.embed = this.route.snapshot.queryParams['embed'] == 'true' ? true : false;
          }
        }
      },
    });
  }
}
